import React from 'react';
import { useLocation } from 'react-router-dom';
import Report from './ProgressReport';
import {getQueryParams} from "../../services/UtilityService";
import AssessmentService from "../../services/TTGAssessmentService";

const ProgressReport = () => {
    const location = useLocation();
    const params = getQueryParams(location.search);
    const assessment = AssessmentService.getReportData(params);

    if (!assessment) {
        return <p>loading</p>;
    }

    return <Report details={assessment} />;
};

export default ProgressReport;
